import {Routes} from '@angular/router';
import {inject} from '@angular/core';
import {AuthenticatedComponent} from './authenticated.component';
import {IsLoggedInGuard} from '../guards/is-logged-in.guard';
import {AccountComponent} from './account/account.component';
import {routes as budgetsRoutes} from './service-provider-budgets/service-provider-budgets.routes';
import {routes as eventCalendarRoutes} from './event-calendar/event-calendar.routes';
import {routes as eventRoutes} from './events/events.routes';
import {FEATURE_FLAG} from '@generated-backend-types';
import {FeatureFlagGuard} from '../guards/feature-flag.guard';
import {UserSessionService} from '../services/user-session-service/user-session.service';
export const routes: Routes = [
  {
    path: '',
    component: AuthenticatedComponent,
    canActivate: [IsLoggedInGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: () => {
          const session = inject(UserSessionService);
          return session.hasAllFeatureFlag([FEATURE_FLAG.SERVICE_PROVIDER_HUB_EVENT_CENTRIC])
            ? 'events'
            : 'event-calendar';
        },
      },
      {
        path: 'account',
        component: AccountComponent,
      },
      {
        path: 'events',
        canActivate: [FeatureFlagGuard],
        data: {
          allFeatureFlagsNeeded: [FEATURE_FLAG.SERVICE_PROVIDER_HUB_EVENT_CENTRIC],
        },
        children: eventRoutes,
      },
      {
        path: 'budgets',
        children: budgetsRoutes,
      },
      {
        path: 'event-calendar',
        children: eventCalendarRoutes,
      },
    ]
  }

];
